export const convertToAMPM = (time24: string): string => {
  //time conversions for am pm format
  const hour: number = parseInt(time24.substring(0, 2), 10);
  const minute: string = time24.substring(3);
  const ampm: string = hour >= 12 ? "PM" : "AM";
  const convertedHour: number = hour % 12 || 12;
  return `${convertedHour}:${minute.slice(0, 2)} ${ampm}`;
};
